import { AddressDTO } from '../services/DTOs/AddressDTO'
import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'addressString',
    standalone: true,
})
export class AddressPipe implements PipeTransform {
    transform(address?: AddressDTO): any {
        let addressString = address ? Object.values(address).filter(Boolean).join(', ') : ''
        return addressString !== '' ? addressString : 'None'
    }
}
